__turbopack_context__.v({
  "boldText": "Location-module__D4BweG__boldText",
  "certificationContent": "Location-module__D4BweG__certificationContent",
  "certificationItem": "Location-module__D4BweG__certificationItem",
  "certificationTitle": "Location-module__D4BweG__certificationTitle",
  "contactWrapper": "Location-module__D4BweG__contactWrapper",
  "description": "Location-module__D4BweG__description",
  "divider": "Location-module__D4BweG__divider",
  "image": "Location-module__D4BweG__image",
  "largeText": "Location-module__D4BweG__largeText",
  "leftPanel": "Location-module__D4BweG__leftPanel",
  "mediaWrapper": "Location-module__D4BweG__mediaWrapper",
  "moduleWrapper": "Location-module__D4BweG__moduleWrapper",
  "normalText": "Location-module__D4BweG__normalText",
  "outerWrapper": "Location-module__D4BweG__outerWrapper",
  "primaryIcon": "Location-module__D4BweG__primaryIcon",
  "rightPanel": "Location-module__D4BweG__rightPanel",
  "root": "Location-module__D4BweG__root",
  "taxonomy": "Location-module__D4BweG__taxonomy",
  "taxonomyItem": "Location-module__D4BweG__taxonomyItem",
  "taxonomyList": "Location-module__D4BweG__taxonomyList",
  "taxonomyWrapper": "Location-module__D4BweG__taxonomyWrapper",
  "virtualTour": "Location-module__D4BweG__virtualTour",
  "wistia": "Location-module__D4BweG__wistia",
});
